"use client";

import { c as _c } from "react/compiler-runtime";
import { useHasMounted } from "@/hooks/useHasMounted";
import { useCookieConsent } from "@/lib/cookies/useCookieConsent";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { useEffect, useState } from "react";

/**
 * Composant qui charge conditionnellement Analytics et SpeedInsights
 * uniquement si l'utilisateur a donné son consentement
 */
export function ConditionalAnalytics() {
  const $ = _c(5);
  const {
    hasConsent,
    isLoading
  } = useCookieConsent();
  const hasMounted = useHasMounted();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [, forceUpdate] = useState(t0);
  let t1;
  if ($[1] !== forceUpdate) {
    t1 = () => {
      const handleConsentChange = () => {
        forceUpdate({});
      };
      window.addEventListener("cookieConsentChange", handleConsentChange as EventListener);
      return () => {
        window.removeEventListener("cookieConsentChange", handleConsentChange as EventListener);
      };
    };
    $[1] = forceUpdate;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!hasMounted || isLoading || !hasConsent("analytics")) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <><Analytics /><SpeedInsights /></>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}